var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-switch',{attrs:{"label":_vm.$t('incidentReports.incidentReportFormLong.temporaryWorker')},model:{value:(_vm.value.temporaryWorker),callback:function ($$v) {_vm.$set(_vm.value, "temporaryWorker", $$v)},expression:"value.temporaryWorker"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }